export const USERNAME_REGEX = /^[a-zA-Z0-9_]+$/;
export const NOT_ALLOW_SEPCIAL_CHARACTER = /^[^a-zA-Z0-9]$/
export const REGEX_EMAIL = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;